"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnimateInOut = void 0;
const react_1 = require("react");
const useAnimateInOut = (initialState = false) => {
    const [status, setStatus] = (0, react_1.useState)(initialState);
    const [display, setDisplay] = (0, react_1.useState)(status);
    const [animateIn, setAnimateIn] = (0, react_1.useState)(false);
    const toggle = (newState) => {
        if (newState !== undefined) {
            setStatus(newState);
        }
        else {
            setStatus((curr) => !curr);
        }
    };
    (0, react_1.useEffect)(() => {
        let timeout;
        if (status) {
            setDisplay(true);
            timeout = setTimeout(() => {
                setAnimateIn(true);
            }, 10);
        }
        else {
            setAnimateIn(false);
            timeout = setTimeout(() => {
                setDisplay(false);
            }, 150);
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [status]);
    return {
        display,
        animateIn,
        toggle,
        status,
    };
};
exports.useAnimateInOut = useAnimateInOut;
